import {configureStore, combineReducers} from '@reduxjs/toolkit';
import setProductReducer from "./SetProductSlice";
import setUserInfoReducer from "./UserInfoSlice";
import authUserReducer from "./AuthSlice";
import setOrderReducer from "./OrderSlice";
import setNewReducer from "./SetNewsSlice";
import setHistoryReducer from "./OrdersHistorySlice";
import setLikedReducer from "./LikedSlice";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';


const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authUser','setLiked']
}

const rootReducer = combineReducers({
    setProduct: setProductReducer,
    authUser: authUserReducer,
    setUserData: setUserInfoReducer,
    setNew: setNewReducer,
    setOrder: setOrderReducer,
    setHistory: setHistoryReducer,
    setLiked: setLikedReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})


export const persistor = persistStore(store);
export default store;